import {MessageThreadType} from "@twigsby/client-data";
import {MessageCentreResponseType} from "@twigsby/client-data/lib/Types/Response/MessageCentreResponseTypes";
import { useTranslation } from "@twigsby/frontend-framework";
import {useState} from "react";

type useMessageItemActionsType = {
    selectionActions: any;
    FilterActions: (messageData: any, selected: any) => void;
}

const useMessageItemActions = (): useMessageItemActionsType => {
    const { t } = useTranslation();
    const [ selectionActions, setSelectionActions ] = useState<any>(null);

    const FilterActions = (messageData: any, selected: any) => {
        if(!messageData || !selected || selected.length < 1 ) {
            setSelectionActions(null);
            return;
        }

        const messageActionsData = [
            {
                name: 'Archive',
                label: t('actions.archive'),
                id: 0,
            },
            {
                name: 'Un-Archive',
                label: t('actions.unArchive'),
                id: 1,
            },
            {
                name: 'Delete',
                label: t('actions.delete'),
                id: 2,
            }
        ];

        let selectedData: Array<MessageThreadType> = messageData.pages ? messageData.pages.map((group: MessageCentreResponseType) => group.data.filter((messageItem) => selected.includes(messageItem.id) ? messageItem : null ))[0] : [messageData];

        let newActions: Array<any> = messageActionsData;
        let exclude: Array<string> = [];

        for (let i = 0; i < selectedData.length; i++) {
            if (selectedData[i].isArchived && !exclude.includes('Archive')) {
                exclude.push('Archive');
            }
            if (!selectedData[i].isArchived && !exclude.includes('Un-Archive')) {
                exclude.push('Un-Archive');
            }
        }

        if(exclude.length > 0) {
            let exclusions = exclude.filter((v, i, a) => a.indexOf(v) === i);

            for (let m = 0; m < newActions.length; m++) {
                newActions[m].disabled = exclusions.includes(newActions[m].name);
            }
        }

        setSelectionActions(newActions);
    };

    return { selectionActions, FilterActions }
}

export default useMessageItemActions
